import { render, staticRenderFns } from "./phone-verify.page.vue?vue&type=template&id=4ffc67fa&"
import script from "./phone-verify.page.vue?vue&type=script&lang=ts&"
export * from "./phone-verify.page.vue?vue&type=script&lang=ts&"
import style0 from "./phone-verify.page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports